import { forwardRef } from 'react';

import type { IconProps } from './types';

/*
 * DO NOT remove `forwardRef`
 * It is used for `motion.create`
 */
const Cross = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props} ref={forwardedRef}>
    <path
      d="M23.747 23.68C9.114 38.308.065 58.522.065 80.846s9.05 42.538 23.682 57.166l373.921 374.053L23.747 885.986C9.114 900.614.065 920.828.065 943.152s9.05 42.538 23.682 57.166C38.375 1014.951 58.589 1024 80.913 1024s42.538-9.05 57.166-23.682L512 626.397l373.921 373.921c14.628 14.633 34.842 23.682 57.166 23.682s42.538-9.05 57.166-23.682c14.633-14.628 23.682-34.842 23.682-57.166s-9.05-42.538-23.682-57.166L626.332 512.065l373.921-374.051c14.633-14.628 23.682-34.842 23.682-57.166s-9.05-42.538-23.682-57.166C985.625 9.049 965.411 0 943.087 0s-42.538 9.05-57.166 23.682L512 397.603 138.079 23.682C123.451 9.049 103.237 0 80.913 0S38.375 9.05 23.747 23.682z"
      fill={color}
    />
  </svg>
));

export default Cross;
